import React from 'react';

const STATUS_BORDER = {
  'Not Started': 'border-slate-300 focus:border-slate-400 focus:ring-slate-300',
  'Work in Progress': 'border-amber-400 focus:border-amber-500 focus:ring-amber-300',
  'Pending with Employer/PF Office': 'border-orange-400 focus:border-orange-500 focus:ring-orange-300',
  Completed: 'border-green-500 focus:border-green-600 focus:ring-green-300',
  'On Hold': 'border-rose-400 focus:border-rose-500 focus:ring-rose-300'
};

const STATUS_LABEL = {
  'Not Started': 'text-slate-500 peer-focus:text-slate-600',
  'Work in Progress': 'text-amber-700 peer-focus:text-amber-700',
  'Pending with Employer/PF Office': 'text-orange-700 peer-focus:text-orange-700',
  Completed: 'text-green-700 peer-focus:text-green-700',
  'On Hold': 'text-rose-700 peer-focus:text-rose-700'
};

/**
 * Outlined floating-label select (border label sits on the outline).
 * Optional statusTone colors the border by activity status.
 */
const OutlinedSelect = ({
  id,
  label,
  value,
  onChange,
  options = [],
  disabled = false,
  className = '',
  statusTone = false
}) => {
  const selectId = id || `outlined-${label?.replace(/\s+/g, '-').toLowerCase()}`;
  const borderClass = statusTone
    ? (STATUS_BORDER[value] || STATUS_BORDER['Not Started'])
    : 'border-slate-300 focus:border-primary-500 focus:ring-primary-500';
  const labelClass = statusTone
    ? (STATUS_LABEL[value] || STATUS_LABEL['Not Started'])
    : 'text-slate-500 peer-focus:text-primary-600';

  return (
    <div className={`relative min-h-[3.25rem] ${className}`}>
      <select
        id={selectId}
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        title={typeof label === 'string' ? label : undefined}
        className={`peer w-full appearance-none rounded-lg border-2 bg-white px-3 pt-5 pb-2 text-sm text-slate-900 outline-none transition focus:ring-1 disabled:bg-slate-50 disabled:text-slate-400 ${borderClass}`}
      >
        {options.map((opt) => {
          const val = typeof opt === 'string' ? opt : opt.value;
          const text = typeof opt === 'string' ? opt : opt.label;
          return (
            <option key={val} value={val}>
              {text}
            </option>
          );
        })}
      </select>
      <label
        htmlFor={selectId}
        className={`pointer-events-none absolute left-2 -top-2 max-w-[calc(100%-1rem)] truncate bg-white px-1 text-[10px] font-semibold leading-tight ${labelClass}`}
        title={typeof label === 'string' ? label : undefined}
      >
        {label}
      </label>
      <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 text-xs">▾</span>
    </div>
  );
};

export default OutlinedSelect;

export const statusTextClass = (status) => {
  switch (status) {
    case 'Completed':
      return 'text-green-700';
    case 'Work in Progress':
      return 'text-amber-700';
    case 'Pending with Employer/PF Office':
      return 'text-orange-700';
    case 'On Hold':
      return 'text-rose-700';
    default:
      return 'text-slate-700';
  }
};
